(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["current-hero"] && !Shopify.designMode) return;
  try {
    
class HeroSlideshow extends HTMLElement {
  constructor() {
    super();
    this.currentSlide = 0;
    this.autoplayTimer = null;
    this.isTransitioning = false;
  }

  connectedCallback() {
    this.slides = this.querySelectorAll('.hero__slide');
    this.dots = this.querySelectorAll('[data-slide-dot]');
    this.prevBtn = this.querySelector('[data-slide-prev]');
    this.nextBtn = this.querySelector('[data-slide-next]');
    this.slideCount = parseInt(this.dataset.slideCount, 10) || 0;
    this.autoplay = this.dataset.autoplay === 'true';
    this.autoplaySpeed = parseInt(this.dataset.autoplaySpeed, 10) || 5000;
    this.transition = this.dataset.transition || 'fade';

    if (this.slideCount < 2) return;

    this.bindEvents();

    if (this.autoplay) {
      this.startAutoplay();
    }
  }

  disconnectedCallback() {
    this.stopAutoplay();
  }

  bindEvents() {
    if (this.prevBtn) {
      this.prevBtn.addEventListener('click', () => this.prev());
    }
    if (this.nextBtn) {
      this.nextBtn.addEventListener('click', () => this.next());
    }

    this.dots.forEach((dot) => {
      dot.addEventListener('click', () => {
        const index = parseInt(dot.dataset.slideDot, 10);
        this.goToSlide(index);
      });
    });

    /* Pause autoplay on hover / focus */
    this.addEventListener('mouseenter', () => this.stopAutoplay());
    this.addEventListener('mouseleave', () => {
      if (this.autoplay) this.startAutoplay();
    });
    this.addEventListener('focusin', () => this.stopAutoplay());
    this.addEventListener('focusout', () => {
      if (this.autoplay) this.startAutoplay();
    });

    /* Swipe support for touch devices */
    let touchStartX = 0;
    let touchEndX = 0;
    const mediaWrapper = this.querySelector('.hero__slideshow');

    if (mediaWrapper) {
      mediaWrapper.addEventListener('touchstart', (e) => {
        touchStartX = e.changedTouches[0].screenX;
      }, { passive: true });

      mediaWrapper.addEventListener('touchend', (e) => {
        touchEndX = e.changedTouches[0].screenX;
        const diff = touchStartX - touchEndX;
        if (Math.abs(diff) > 50) {
          if (diff > 0) {
            this.next();
          } else {
            this.prev();
          }
        }
      }, { passive: true });
    }
  }

  prev() {
    if (this.isTransitioning) return;
    const prevIndex = (this.currentSlide - 1 + this.slides.length) % this.slides.length;
    this.goToSlide(prevIndex);
  }

  next() {
    if (this.isTransitioning) return;
    const nextIndex = (this.currentSlide + 1) % this.slides.length;
    this.goToSlide(nextIndex);
  }

  goToSlide(index) {
    if (index === this.currentSlide || this.isTransitioning) return;

    this.isTransitioning = true;
    const prevSlide = this.slides[this.currentSlide];
    const nextSlide = this.slides[index];

    if (this.transition === 'slide') {
      /* For slide transition, handle exit class */
      prevSlide.classList.add('hero__slide--exit-left');
      prevSlide.classList.remove('hero__slide--active');
      nextSlide.classList.add('hero__slide--active');

      const duration = parseInt(getComputedStyle(this).getPropertyValue('--slideshow-transition-duration'), 10) || 600;

      setTimeout(() => {
        prevSlide.classList.remove('hero__slide--exit-left');
        this.isTransitioning = false;
      }, duration);
    } else {
      /* Fade transition (default) */
      prevSlide.classList.remove('hero__slide--active');
      nextSlide.classList.add('hero__slide--active');

      const duration = parseInt(getComputedStyle(this).getPropertyValue('--slideshow-transition-duration'), 10) || 600;

      setTimeout(() => {
        this.isTransitioning = false;
      }, duration);
    }

    /* Pause video on previous slide, play on next */
    const prevVideos = prevSlide.querySelectorAll('video');
    const nextVideos = nextSlide.querySelectorAll('video');
    prevVideos.forEach((v) => v.pause());
    nextVideos.forEach((v) => v.play().catch(() => {}));

    /* Update dots */
    this.dots.forEach((dot) => {
      dot.classList.remove('hero__slideshow-dot--active');
      dot.setAttribute('aria-selected', 'false');
    });
    if (this.dots[index]) {
      this.dots[index].classList.add('hero__slideshow-dot--active');
      this.dots[index].setAttribute('aria-selected', 'true');
    }

    this.currentSlide = index;

    /* Restart autoplay timer */
    if (this.autoplay) {
      this.stopAutoplay();
      this.startAutoplay();
    }
  }

  startAutoplay() {
    this.stopAutoplay();
    this.autoplayTimer = setInterval(() => this.next(), this.autoplaySpeed);
  }

  stopAutoplay() {
    if (this.autoplayTimer) {
      clearInterval(this.autoplayTimer);
      this.autoplayTimer = null;
    }
  }
}

if (!customElements.get('hero-slideshow')) {
  customElements.define('hero-slideshow', HeroSlideshow);
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
